import React, { useEffect, useState } from "react";
import { Modal, Button, Accordion, Card } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { modeConstants } from "../constants";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../redux/actions";
import PhoneInput from "react-phone-input-2";
import { getUserData } from "../system";

// --- Schema ---
// Profile fields are light validation here.
// Passwords: only required if user is changing password.
// If any of current/new/confirm is provided, we require all three and ensure match & min length.
const schema = z
  .object({
    email: z.string().min(2, "The field is required"),
    // change password section
    current_password: z.string().optional(),
    new_password: z.string().optional(),
    confirmPassword: z.string().optional(),
  })
  .superRefine((val, ctx) => {
    const anyPasswordEntered =
      (val.current_password && val.current_password.length > 0) ||
      (val.new_password && val.new_password.length > 0) ||
      (val.confirmPassword && val.confirmPassword.length > 0);

    if (anyPasswordEntered) {
      if (!val.current_password) {
        ctx.addIssue({
          path: ["current_password"],
          code: z.ZodIssueCode.custom,
          message: "Current password is required.",
        });
      }
      if (!val.new_password || val.new_password.length < 6) {
        ctx.addIssue({
          path: ["new_password"],
          code: z.ZodIssueCode.custom,
          message: "New password must be at least 6 characters.",
        });
      }
      if (!val.confirmPassword) {
        ctx.addIssue({
          path: ["confirmPassword"],
          code: z.ZodIssueCode.custom,
          message: "Please confirm the new password.",
        });
      }
      if (
        val.new_password &&
        val.confirmPassword &&
        val.new_password !== val.confirmPassword
      ) {
        ctx.addIssue({
          path: ["confirmPassword"],
          code: z.ZodIssueCode.custom,
          message: "Passwords do not match.",
        });
      }
    }
  });

// --- Defaults ---
const DEFAULT_VALUES = {
  name: "",
  email: "",
  current_password: "",
  new_password: "",
  confirmPassword: "",
};

export default function ProfileModal({ showModal, onHide, mode }) {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: DEFAULT_VALUES,
  });

  const isAdd = mode === modeConstants?.ADD_MODE;
  const isEdit = mode === modeConstants?.UPDATE_MODE;
  const isView = mode === modeConstants?.VIEW_MODE;
  const dispatch = useDispatch();
  const initialData = getUserData();
  const [profilePicFile, setProfilePicFile] = useState(null);
  const [previewPic, setPreviewPic] = useState("");

  // Password visibility toggles
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  // Prefill on open
  useEffect(() => {
    if (!showModal) return;

    if (isAdd) {
      reset(DEFAULT_VALUES);
      return;
    }

    if (initialData && isEdit) {
      reset({
        name: initialData.name ?? "",
        email: initialData.email ?? "",
        pic: null,
        current_password: "",
        new_password: "",
        confirmPassword: "",
      });

      // show existing image if present
      if (initialData.pic_url) {
        // if backend returns full url, just use it
        setPreviewPic(process.env.REACT_APP_STORAGE_URL + initialData.pic_url);
      } else {
        setPreviewPic("");
        setProfilePicFile(null);
      }
      return;
    }
  }, [showModal]);

  const onSubmit = (data) => {
    console.log("profilePicFile", profilePicFile);
    // create FormData instance
    const formData = new FormData();
    // Append profile fields
    formData.append("id", initialData?.id || "");
    formData.append("email", data.email || "");
    formData.append("name", data.name || "");

    // Append password fields (only if user wants to change password)
    if (data.current_password || data.new_password) {
      formData.append("current_password", data.current_password || "");
      formData.append("new_password", data.new_password || "");
    }

    // Handle file upload if provided
    if (profilePicFile instanceof File) {
      formData.append("profile_pic", profilePicFile, profilePicFile.name);
    }

    dispatch(userActions.changePassword(formData, onHide));
  };

  const title = "Profile";

  return (
    <Modal
      show={showModal}
      onHide={onHide}
      size="lg"
      backdrop="static"
      centered
      animation
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)}>
          <fieldset disabled={isView}>
            {/* ===== Profile Details ===== */}
            <Card className="mb-3">
              <Card.Header className="fw-semibold">Profile Details</Card.Header>
              <Card.Body>
                <div className="row g-4 align-items-center">
                  {/* Profile Image */}
                  {/* <div className="col-12 col-lg-6">
                    <div className="d-flex align-items-center gap-3">
                      <div
                        style={{
                          width: 110,
                          height: 110,
                          borderRadius: "50%",
                          background: "#eef5ff",
                          overflow: "hidden",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {previewPic ? (
                          <img
                            src={previewPic}
                            alt="profile"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <i
                            className="bi bi-person-fill"
                            style={{ fontSize: 56 }}
                          />
                        )}
                      </div>

                      <div className="flex-grow-1">
                        <div className="form-floating">
                          <input
                            id="pp"
                            type="file"
                            accept="image/*"
                            className="form-control"
                            onChange={(e) => {
                              const f = e.target.files?.[0];
                              setProfilePicFile(f || null);
                              if (f) setPreviewPic(URL.createObjectURL(f));
                            }}
                          />
                          <label htmlFor="pp">Profile Picture</label>
                        </div>
                      </div>
                    </div>
                  </div> */}

<div className="col-12 col-lg-6">
                    <div className="form-floating">
                      <input
                        id="name"
                        type="text"
                        className="form-control"
                        placeholder="Name"
                        {...register("name")}
                      />
                      <label htmlFor="name">Name</label>
                    </div>
                    {errors.name && (
                      <small className="text-danger">
                        {errors.name.message}
                      </small>
                    )}
                  </div>
                  {/* Email */}
                  <div className="col-12 col-lg-6">
                    <div className="form-floating">
                      <input
                        id="email"
                        type="email"
                        className="form-control"
                        placeholder="Email"
                        {...register("email")}
                      />
                      <label htmlFor="email">Email</label>
                    </div>
                    {errors.email && (
                      <small className="text-danger">
                        {errors.email.message}
                      </small>
                    )}
                  </div>
                </div>
              </Card.Body>
            </Card>

              <Card>
                <Card.Header className="fw-semibold">Change Password</Card.Header>
                <Card.Body>
                  <div className="row g-3">
                    {/* Current */}
                    <div className="col-12 col-lg-4">
                      <div className="input-group">
                        <div className="form-floating flex-grow-1">
                          <input
                            id="current_password"
                            type={showCurrent ? "text" : "password"}
                            className="form-control"
                            placeholder="Current Password"
                            {...register("current_password")}
                          />
                          <label htmlFor="current_password">
                            Current Password
                          </label>
                        </div>
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={() => setShowCurrent((v) => !v)}
                        >
                          <i
                            className={
                              showCurrent ? "ri-eye-off-line" : "ri-eye-line"
                            }
                          />
                        </button>
                      </div>
                      {errors.current_password && (
                        <small className="text-danger">
                          {errors.current_password.message}
                        </small>
                      )}
                    </div>

                    {/* New */}
                    <div className="col-12 col-lg-4">
                      <div className="input-group">
                        <div className="form-floating flex-grow-1">
                          <input
                            id="new_password"
                            type={showNew ? "text" : "password"}
                            className="form-control"
                            placeholder="New Password"
                            {...register("new_password")}
                          />
                          <label htmlFor="new_password">New Password</label>
                        </div>
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={() => setShowNew((v) => !v)}
                        >
                          <i
                            className={
                              showNew ? "ri-eye-off-line" : "ri-eye-line"
                            }
                          />
                        </button>
                      </div>
                      {errors.new_password && (
                        <small className="text-danger">
                          {errors.new_password.message}
                        </small>
                      )}
                    </div>

                    {/* Confirm */}
                    <div className="col-12 col-lg-4">
                      <div className="input-group">
                        <div className="form-floating flex-grow-1">
                          <input
                            id="confirmPassword"
                            type={showConfirm ? "text" : "password"}
                            className="form-control"
                            placeholder="Confirm Password"
                            {...register("confirmPassword")}
                          />
                          <label htmlFor="confirmPassword">
                            Confirm Password
                          </label>
                        </div>
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={() => setShowConfirm((v) => !v)}
                        >
                          <i
                            className={
                              showConfirm ? "ri-eye-off-line" : "ri-eye-line"
                            }
                          />
                        </button>
                      </div>
                      {errors.confirmPassword && (
                        <small className="text-danger">
                          {errors.confirmPassword.message}
                        </small>
                      )}
                    </div>

                    <div className="col-12">
                      <small className="text-muted">
                        Leave password fields blank if you don’t want to change
                        your password.
                      </small>
                    </div>
                  </div>
                </Card.Body>
              </Card>
          </fieldset>

          {/* Buttons section intentionally unchanged */}
          <div className="d-flex justify-content-end gap-2 footer-modal">
            <Button
              variant="outline-secondary"
              onClick={onHide}
              className="btn-footer"
            >
              {isView ? "Close" : "Cancel"}
            </Button>
            {!isView  && (
              <Button type="submit" variant="success" className="btn-footer">
                Save Changes
              </Button>
            )}
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}
